"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _createForOfIteratorHelper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DefaultBrowserBehavior_1 = require("../browserbehavior/DefaultBrowserBehavior");
/**
 * A device that augments a {@link Device} to apply Amazon Voice Focus
 * noise suppression to an audio input.
 */


var VoiceFocusTransformDevice = /*#__PURE__*/function () {
  /** @internal */
  function VoiceFocusTransformDevice(device, voiceFocus, delegate, nodeOptions) {
    var failed = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var node = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
    var browserBehavior = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : new DefaultBrowserBehavior_1.default();
    var farEndStreamToAudioSourceNode = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : new Map();
    var mixDestNode = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : undefined;
    var mixSourceNode = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : undefined;

    _classCallCheck(this, VoiceFocusTransformDevice);

    this.device = device;
    this.voiceFocus = voiceFocus;
    this.delegate = delegate;
    this.nodeOptions = nodeOptions;
    this.failed = failed;
    this.node = node;
    this.browserBehavior = browserBehavior;
    this.farEndStreamToAudioSourceNode = farEndStreamToAudioSourceNode;
    this.mixDestNode = mixDestNode;
    this.mixSourceNode = mixSourceNode;
  }
  /**
   * Return the inner device as provided during construction, or updated via
   * {@link VoiceFocusTransformDevice.chooseNewInnerDevice}. Do not confuse
   * this method with {@link VoiceFocusTransformDevice.intrinsicDevice}.
   */


  _createClass(VoiceFocusTransformDevice, [{
    key: "getInnerDevice",
    value: function getInnerDevice() {
      return this.device;
    }
    /**
     * Disable the audio node while muted to reduce CPU usage.
     *
     * @param muted whether the audio device should be muted.
     */

  }, {
    key: "mute",
    value: function mute(muted) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.node) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (!muted) {
                  _context.next = 7;
                  break;
                }

                _context.next = 5;
                return this.node.disable();

              case 5:
                _context.next = 9;
                break;

              case 7:
                _context.next = 9;
                return this.node.enable();

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Dispose of the inner workings of the transform device. After this method is called
     * you will need to create a new device to use Amazon Voice Focus again.
     */

  }, {
    key: "stop",
    value: function stop() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.node) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                this.node.disconnect();
                _context2.next = 5;
                return this.node.stop();

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * If you wish to choose a different inner device, but continue to use Amazon Voice Focus, you
     * can use this method to efficiently create a new device that will reuse
     * the same internal state. Only one of the two devices can be used at a time: switch
     * between them using {@link DeviceController.chooseAudioInputDevice}.
     *
     * If the same device is passed as is currently in use, `this` is returned.
     *
     * @param inner The new inner device to use.
     */

  }, {
    key: "chooseNewInnerDevice",
    value: function chooseNewInnerDevice(inner) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.device === inner && !isDefaultDevice(inner))) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", this);

              case 2:
                return _context3.abrupt("return", new VoiceFocusTransformDevice(inner, this.voiceFocus, this.delegate, this.nodeOptions, this.failed, this.node, this.browserBehavior, this.farEndStreamToAudioSourceNode, this.mixDestNode, this.mixSourceNode));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "intrinsicDevice",
    value: function intrinsicDevice() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var isUsingES, trackConstraints, useBuiltInAGC;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!this.failed) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return", this.device);

              case 2:
                isUsingES = this.nodeOptions.es; // Turn the Device into constraints with appropriate AGC settings.

                trackConstraints = {
                  echoCancellation: !isUsingES,
                  // @ts-ignore
                  googEchoCancellation: !isUsingES,
                  // @ts-ignore
                  googEchoCancellation2: !isUsingES,
                  noiseSuppression: false,
                  // @ts-ignore
                  googNoiseSuppression: false,
                  // @ts-ignore
                  googHighpassFilter: false,
                  // @ts-ignore
                  googNoiseSuppression2: false
                };

                if (this.nodeOptions && this.nodeOptions.agc !== undefined) {
                  useBuiltInAGC = this.nodeOptions.agc.useBuiltInAGC;
                } else {
                  useBuiltInAGC = true;
                }

                trackConstraints.autoGainControl = useBuiltInAGC; // @ts-ignore

                trackConstraints.googAutoGainControl = useBuiltInAGC; // @ts-ignore

                trackConstraints.googAutoGainControl2 = useBuiltInAGC; // Empty string and null.

                if (this.device) {
                  _context4.next = 10;
                  break;
                }

                return _context4.abrupt("return", trackConstraints);

              case 10:
                if (!(typeof this.device === 'string')) {
                  _context4.next = 13;
                  break;
                }

                /* istanbul ignore if */
                if (this.browserBehavior.requiresNoExactMediaStreamConstraints()) {
                  trackConstraints.deviceId = this.device;
                } else {
                  trackConstraints.deviceId = {
                    exact: this.device
                  };
                }

                return _context4.abrupt("return", trackConstraints);

              case 13:
                if (!this.device.id) {
                  _context4.next = 15;
                  break;
                }

                return _context4.abrupt("return", this.device);

              case 15:
                return _context4.abrupt("return", Object.assign(Object.assign({}, this.device), trackConstraints));

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "createAudioNode",
    value: function createAudioNode(context) {
      var _a, _b;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var agc, options, _iterator, _step, stream, start, end;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(((_a = this.node) === null || _a === void 0 ? void 0 : _a.context) === context)) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return", {
                  start: this.node,
                  end: this.node
                });

              case 2:
                agc = {
                  useVoiceFocusAGC: false
                };
                options = Object.assign({
                  enabled: true,
                  agc: agc
                }, this.nodeOptions);
                _context5.prev = 4;
                (_b = this.node) === null || _b === void 0 ? void 0 : _b.disconnect();
                _context5.next = 8;
                return this.voiceFocus.createNode(context, options);

              case 8:
                this.node = _context5.sent;

                if (this.nodeOptions.es) {
                  this.mixDestNode = new MediaStreamAudioDestinationNode(context, {
                    channelCount: 1,
                    channelCountMode: 'explicit'
                  });
                  _iterator = _createForOfIteratorHelper(this.farEndStreamToAudioSourceNode.keys());

                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      stream = _step.value;
                      this.assignFarEndStreamToAudioSourceNode(stream);
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }

                  this.createMixSourceNode();
                }

                start = this.node;
                end = this.node;
                return _context5.abrupt("return", {
                  start: start,
                  end: end
                });

              case 15:
                _context5.prev = 15;
                _context5.t0 = _context5["catch"](4);
                // It's better to return some audio stream than nothing.
                this.failed = true;
                this.delegate.onFallback(this, _context5.t0);
                throw _context5.t0;

              case 20:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[4, 15]]);
      }));
    }
  }, {
    key: "observeMeetingAudio",
    value: function observeMeetingAudio(audioVideo) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var stream;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (this.nodeOptions.es) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return");

              case 2:
                audioVideo.addAudioMixObserver(this);
                _context6.next = 5;
                return audioVideo.getCurrentMeetingAudioStream();

              case 5:
                stream = _context6.sent;

                if (stream) {
                  this.addFarEndStream(stream);
                }

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "unObserveMeetingAudio",
    value: function unObserveMeetingAudio(audioVideo) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var stream;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (this.nodeOptions.es) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return");

              case 2:
                audioVideo.removeAudioMixObserver(this);
                _context7.next = 5;
                return audioVideo.getCurrentMeetingAudioStream();

              case 5:
                stream = _context7.sent;

                if (stream) {
                  this.removeFarendStream(stream);
                }

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
    /**
     * Add an observer to receive notifications about Amazon Voice Focus lifecycle events.
     * See {@link VoiceFocusTransformDeviceObserver} for details.
     * If the observer has already been added, this method call has no effect.
     */

  }, {
    key: "addObserver",
    value: function addObserver(observer) {
      this.delegate.addObserver(observer);
    }
    /**
     * Remove an existing observer. If the observer has not been previously {@link
     * VoiceFocusTransformDevice.addObserver|added}, this method call has no effect.
     */

  }, {
    key: "removeObserver",
    value: function removeObserver(observer) {
      this.delegate.removeObserver(observer);
    }
  }, {
    key: "addFarEndStream",
    value: function addFarEndStream(activeStream) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(!this.nodeOptions.es || !activeStream || this.farEndStreamToAudioSourceNode.has(activeStream))) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt("return");

              case 2:
                if (this.node) {
                  this.assignFarEndStreamToAudioSourceNode(activeStream);
                } else {
                  this.farEndStreamToAudioSourceNode.set(activeStream, null);
                }

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "removeFarendStream",
    value: function removeFarendStream(inactiveStream) {
      var _a;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                (_a = this.farEndStreamToAudioSourceNode.get(inactiveStream)) === null || _a === void 0 ? void 0 : _a.disconnect();
                this.farEndStreamToAudioSourceNode.delete(inactiveStream);

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "meetingAudioStreamBecameActive",
    value: function meetingAudioStreamBecameActive(activeStream) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                this.addFarEndStream(activeStream);

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "meetingAudioStreamBecameInactive",
    value: function meetingAudioStreamBecameInactive(inactiveStream) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                this.removeFarendStream(inactiveStream);

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: "assignFarEndStreamToAudioSourceNode",
    value: function assignFarEndStreamToAudioSourceNode(streamToAdd) {
      var streamNodeToAdd = this.node.context.createMediaStreamSource(streamToAdd);
      streamNodeToAdd.channelCount = 1;
      streamNodeToAdd.channelCountMode = 'explicit';
      this.farEndStreamToAudioSourceNode.set(streamToAdd, streamNodeToAdd);
      streamNodeToAdd.connect(this.mixDestNode, 0);
    }
  }, {
    key: "createMixSourceNode",
    value: function createMixSourceNode() {
      this.mixSourceNode = this.node.context.createMediaStreamSource(this.mixDestNode.stream);
      this.mixSourceNode.channelCount = 1;
      this.mixSourceNode.channelCountMode = 'explicit';
      this.mixSourceNode.connect(this.node, 0, 1);
    }
  }]);

  return VoiceFocusTransformDevice;
}();

function isDefaultDevice(device) {
  if (device === 'default') {
    return true;
  }

  if (!device || typeof device !== 'object') {
    return false;
  }

  if ('deviceId' in device && device.deviceId === 'default') {
    return true;
  }

  if ('id' in device && device.id === 'default') {
    return true;
  }

  return false;
}

exports.default = VoiceFocusTransformDevice;